var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftDoubleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61071 1.1452L5.95037 4.80554C5.84275 4.91316 5.84275 5.08728 5.95037 5.19446L9.61071 8.8548C9.81764 9.06173 9.81764 9.39727 9.61071 9.60463L9.37054 9.84481C9.16362 10.0517 8.82807 10.0517 8.62071 9.84481L4.15847 5.38257C3.94717 5.17127 3.94717 4.82873 4.15847 4.61743L8.62071 0.155194C8.82764 -0.0517312 9.16318 -0.0517312 9.37054 0.155194L9.61071 0.395367C9.81764 0.602292 9.81764 0.937835 9.61071 1.1452Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61071 1.1452L1.95037 4.80554C1.84275 4.91316 1.84275 5.08728 1.95037 5.19446L5.61071 8.8548C5.81764 9.06173 5.81764 9.39727 5.61071 9.60463L5.37054 9.84481C5.16362 10.0517 4.82807 10.0517 4.62071 9.84481L0.158475 5.38257C-0.0528252 5.17127 -0.0528252 4.82873 0.158475 4.61743L4.62071 0.155194C4.82764 -0.0517312 5.16318 -0.0517312 5.37054 0.155194L5.61071 0.395367C5.81764 0.602292 5.81764 0.937835 5.61071 1.1452Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDoubleIcon);
export default __webpack_public_path__ + "static/media/ArrowLeftDoubleIcon.986868970598ad46156bf21549d4441e.svg";
export { ForwardRef as ReactComponent };